
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsConceptGrid extends Serenity.EntityGrid<CsConceptRow, any> {
        protected getColumnsKey() { return CsConceptColumns.columnsKey; }
        protected getDialogType() { return CsConceptDialog; }
        protected getIdProperty() { return CsConceptRow.idProperty; }
        protected getInsertPermission() { return CsConceptRow.insertPermission; }
        protected getLocalTextPrefix() { return CsConceptRow.localTextPrefix; }
        protected getService() { return CsConceptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}